<button
  type="button"
  [class]="classes"
  [disabled]="disabled"
  [attr.aria-label]="a11yLabel"
  [matTooltip]="tooltip || (variant === 'icon' ? label : '')"
  matTooltipPosition="above"
  (click)="onClick($event)"
>
  <svg
    [class]="iconSizeClass + ' shrink-0'"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    aria-hidden="true"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M10 19l-7-7m0 0l7-7m-7 7h18"
    />
  </svg>
  <span *ngIf="variant !== 'icon'">{{ label }}</span>
</button>
